(function () {
  'use strict';

  angular
    .module('settings.stacking.plan')
    .controller('settingsStackingPlanCtrl', settingsStackingPlanCtrl);

  settingsStackingPlanCtrl.$inject = ['SettingsStackingPlan'];

  function settingsStackingPlanCtrl(SettingsStackingPlan) {
    var vm = this;

    vm.unitFeatureList = [];
    vm.unitFeature = {};
    vm.onUnitFeatureCreate = onUnitFeatureCreate;
    vm.onUnitFeatureUpdate = onUnitFeatureUpdate;
    vm.onUnitFeatureDelete = onUnitFeatureDelete;

    getUnitFeatureList();

    function getUnitFeatureList() {
      SettingsStackingPlan.getUnitFeatureList(function (response) {
        vm.unitFeatureList = response;
      });
    }

    function onUnitFeatureCreate() {
      var params = {
        custom_type: 'label',
      };

      SettingsStackingPlan.create(params, vm.unitFeature, function (response) {
        vm.unitFeatureList.push(response);
        vm.unitFeature = {};
      });
    }

    function onUnitFeatureUpdate(object) {
      var params = {
        custom_type: 'label',
        id: object.id,
      };

      SettingsStackingPlan.update(params, object, function (response) {});
    }

    function onUnitFeatureDelete(object) {
      var params = {
        custom_type: 'label',
        id: object.id,
      };

      SettingsStackingPlan.delete(params, object, function (response) {
        vm.unitFeatureList.splice(vm.unitFeatureList.indexOf(object), 1);
      });
    }
  }
})();
